import { Box } from '@mui/material';
import ChatContainer from '../components/chat/ChatContainer';

export default function AgenticAIPage() {
  return (
    <Box
      sx={{
        height: 'calc(100vh - 130px)',
        minHeight: 560,
        width: '100%',
        maxWidth: '100%',
        mx: 0,
        px: 0,
      }}
    >
      <ChatContainer
        isOpen
        pageMode
        showHeader={false}
        showCloseButton={false}
      />
    </Box>
  );
}
